<template>
    <div class="min-h-screen bg-valence-cream-50 relative">
        <!-- Top-right meta pill: org logo (when white-labeled) + Nadia attribution + auth state. -->
        <div class="absolute top-6 right-6 sm:top-8 sm:right-10 flex items-center gap-3 z-10">
            <img v-if="orgLogoUrl" :src="orgLogoUrl" :alt="`${orgName ?? 'Organization'} logo`" class="h-5 max-w-[80px] object-contain" />
            <span class="details text-valence-stone-500">Powered by Nadia · Valence</span>
            <span v-if="showAnonymous" class="details text-valence-stone-500 flex items-center gap-1.5 pl-3 border-l border-valence-cream-300">
                <i class="bi bi-shield-lock" aria-hidden="true"></i> Anonymous
            </span>
            <span v-else class="details text-valence-stone-500 flex items-center gap-1.5 pl-3 border-l border-valence-cream-300">
                <i class="bi bi-person-circle" aria-hidden="true"></i> Signed in
            </span>
        </div>

        <main class="mx-auto w-full px-6 sm:px-10 pt-24 sm:pt-28 pb-16 flex flex-col gap-6" :style="{ maxWidth: maxWidth + 'px' }">
            <slot />
        </main>
    </div>
</template>

<script setup lang="ts">
import type { OrganizationDetails } from "~vue/appTypes";
import { computed, inject, type Ref } from "vue";

interface Props {
    maxWidth?: number;
    // Pages pass `!invite.is_authenticated` here so authenticated visitors see
    // "Signed in" instead of the anonymity chip. Defaults to true so anyone
    // who lands on a rater page pre-invite-fetch sees the safer default.
    showAnonymous?: boolean;
}

withDefaults(defineProps<Props>(), {
    maxWidth: 640,
    showAnonymous: true,
});

const organizationDetails = inject<Ref<OrganizationDetails | null>>("organization_details");
const orgLogoUrl = computed(() => organizationDetails?.value?.logo_url ?? null);
const orgName = computed(() => organizationDetails?.value?.name ?? null);
</script>
